import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2024ProgramaInformatico() {
  return <CategoryPage category="anexo30Y31Ano2024ProgramaInformatico" pageTitle="Programa Informatico 2024" />;
}

export default Anexo30Y31Ano2024ProgramaInformatico;
